import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchAPI } from "@coworker/app/src/hooks/API/tasks.service.helper";
import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";

async function updateUserLastActiveAtByFixaUid(fixaUid: string) {
  const path = `users/${fixaUid}/last-active-at`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await fetchAPI("PUT", url, {});
}

export const useUpdateUserLastActiveAt = (fixaUid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => updateUserLastActiveAtByFixaUid(fixaUid),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: ["user", fixaUid],
      });
    },
  });
};
